import { render, staticRenderFns } from "./dialogActionButtons.vue?vue&type=template&id=4818e286&scoped=true"
import script from "./dialogActionButtons.vue?vue&type=script&lang=js"
export * from "./dialogActionButtons.vue?vue&type=script&lang=js"
import style0 from "./dialogActionButtons.vue?vue&type=style&index=0&id=4818e286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4818e286",
  null
  
)

export default component.exports